import { Decoder, number, object, string } from '@mojotech/json-type-validation'

import { programLanguageTypeDecoder } from '../language/programLanguageTypeDecoder'

import { ArenaUserSubmission } from '@/domain/entities/arena/arenaUserSubmission'
import { convertJudgeStatusType } from '@/domain/value_objects/judge/JudgeStatusType'

export const arenaUserSubmissionDecoder: Decoder<ArenaUserSubmission> = object({
  judgeId: number(),
  source: string(),
  judgeType: number(),
  arenaId: string(),
  userId: string(),
  problemId: string(),
  submissionDate: number().map(x => new Date(x)),
  judgeDate: number().map(x => new Date(x)),
  language: programLanguageTypeDecoder,
  cpuTime: number(),
  memory: number(),
  status: number().map(x => convertJudgeStatusType(x)),
  accuracy: string()
})
